import { getPlans } from 'helpers/api-calls/plan-calls';

import actions from './actions';

const fetchPlans = (location_id) => (dispatch) => {
  dispatch(actions.requestPlans(true));
  return getPlans(location_id).then(({ data }) => {
    dispatch(actions.hydratePlans(data.plans));
  }).catch((error) => {
    console.log(`fetchPlans error: ${error}`);
  });
};

export default {
  fetchPlans,
};
